// the simple interaction event/widget editing view which corresponds to CS1Surveys
// MVP - compatible

import React from "react";
import TextField from "@mui/material/TextField";
import Interaction from "../../../../../models/interactions/Interaction";
import InteractionSettings from "../../../../../models/config/InteractionSettings";

interface EditPathwayProps {
  interaction: Interaction;
  handlePathwayNameMapping: (value: any) => void;
  handlePathwayPropsMapping: (value: any) => void;
  handlePathwayAnchorMapping: (value: any) => void;
}

const EditPathway = (props: EditPathwayProps) => {
  let surveyName: string | undefined;
  if (
    Object.prototype.hasOwnProperty.call(
      props.interaction.properties,
      "cacheFile",
    )
  ) {
    surveyName = JSON.stringify(props.interaction.properties);
    const surveySettings: InteractionSettings = JSON.parse(surveyName);
    surveyName = surveySettings.cacheFile;
  }

  // get anchor pertaining to this interaction
  // TODO - might need to update to an array of anchors if this needs to handle multiple anchors
  // DONT NEED FOR NOW SINCE ANCHORS ARENT SPECIFIC DATES IN THIS APP
  // useEffect(() => {
  //   let url =
  //     process.env.REACT_APP_API_URL +
  //     `/anchor?interaction_id=eq.${props.interaction.id}`;
  //   let requestSettings = {
  //     url: url,
  //     headers: {
  //       Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
  //     },
  //   };
  //   //    fetchData(requestSettings, (data: Array<Anchor>) => {
  //   //     let anchor = anchorsHandleFetch(data);
  //   //     setPathwayAnchor(anchor[0]);
  //   //     setValue(dayjs(anchor[0].date))
  //   //   });
  // }, []);

  // the cs1survey event type is very simple, and only needs to receive 1 setting right now: the mapped PRO
  return (
    <div>
      <div style={{ padding: "10px" }}>
        <TextField
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.handlePathwayNameMapping(event.target.value);
          }}
          sx={{ width: "99%" }}
          id="outlined-required"
          label="Title"
          defaultValue={props.interaction.title}
        />
      </div>
      <div style={{ padding: "10px" }}>
        {/* commenting out datepicker, because I don't think its needed? Check with Mark */}
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker', 'DatePicker']}>
          <DatePicker
            label="Controlled picker"
            value={value}
            onChange={(newValue) => setValue(newValue)}
          />
        </DemoContainer>
      </LocalizationProvider>         */}

        {/* commenting other text fields, because Im not sure what other pathway props we need besides name */}
        {/* <TextField
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.handlePathwayPropsMapping(event.target.value);
          }}
          sx={{ width: "99%" }}
          id="outlined-required"
          label="Mapped Survey"
          defaultValue={surveyName}
        /> */}
      </div>
    </div>
  );
};

export default EditPathway;
